import { ChangeOptionType } from 'app/area/favourite-administration/list/types';
import { ValidationProps } from 'ui';
import { FavouriteSearchData, FavouriteSearchModel } from './types-store';

export const ACTION = {
  REQUEST_LIST: 'FAVOURITE_ADMINISTRATION:REQUEST_LIST',
  RECEIVE_LIST: 'FAVOURITE_ADMINISTRATION:RECEIVE_LIST',
  FAIL_LIST: 'FAVOURITE_ADMINISTRATION:FAIL_LIST',

  REQUEST_DELETE_FAVOURITE: 'FAVOURITE_ADMINISTRATION:REQUEST_DELETE_FAVOURITE',
  RECEIVE_DELETE_FAVOURITE: 'FAVOURITE_ADMINISTRATION:RECEIVE_DELETE_FAVOURITE',
  FAIL_DELETE_FAVOURITE: 'FAVOURITE_ADMINISTRATION:FAIL_DELETE_FAVOURITE',

  REQUEST_CHANGE_OWNER: 'FAVOURITE_ADMINISTRATION:REQUEST_CHANGE_OWNER',
  RECEIVE_CHANGE_OWNER: 'FAVOURITE_ADMINISTRATION:RECEIVE_CHANGE_OWNER',
  FAIL_CHANGE_OWNER: 'FAVOURITE_ADMINISTRATION:FAIL_CHANGE_OWNER',
  CHANGE_OWNER_FIELDS_BY_KEY: 'FAVOURITE_ADMINISTRATION:CHANGE_OWNER_FIELDS_BY_KEY',
  UPDATE_CHANGE_OWNER_VALIDATION: 'FAVOURITE_ADMINISTRATION:UPDATE_CHANGE_OWNER_VALIDATION',
  UPDATE_CHANGE_OWNER_IS_DIRTY: 'FAVOURITE_ADMINISTRATION:UPDATE_CHANGE_OWNER_IS_DIRTY',
  CLEAR_CHANGE_OWNER: 'FAVOURITE_ADMINISTRATION:CLEAR_CHANGE_OWNER',
  RESET_CHANGE_OWNER_VALIDATION: 'FAVOURITE_ADMINISTRATION:RESET_CHANGE_OWNER_VALIDATION',

  REQUEST_CHANGE_USER_GROUPS: 'FAVOURITE_ADMINISTRATION:REQUEST_CHANGE_USER_GROUPS',
  RECEIVE_CHANGE_USER_GROUPS: 'FAVOURITE_ADMINISTRATION:RECEIVE_CHANGE_USER_GROUPS',
  FAIL_CHANGE_USER_GROUPS: 'FAVOURITE_ADMINISTRATION:FAIL_CHANGE_USER_GROUPS',
  CHANGE_USER_GROUPS_FIELDS_BY_KEY: 'FAVOURITE_ADMINISTRATION:CHANGE_USER_GROUPS_FIELDS_BY_KEY',
  UPDATE_CHANGE_USER_GROUPS_VALIDATION: 'FAVOURITE_ADMINISTRATION:UPDATE_CHANGE_USER_GROUPS_VALIDATION',
  UPDATE_CHANGE_USER_GROUPS_IS_DIRTY: 'FAVOURITE_ADMINISTRATION:UPDATE_CHANGE_USER_GROUPS_IS_DIRTY',
  UPDATE_CHANGE_USER_GROUPS_STATE: 'FAVOURITE_ADMINISTRATION:UPDATE_CHANGE_USER_GROUPS_STATE',
  CLEAR_CHANGE_USER_GROUPS: 'FAVOURITE_ADMINISTRATION:CLEAR_CHANGE_USER_GROUPS',
  RESET_CHANGE_USER_GROUPS_VALIDATION: 'FAVOURITE_ADMINISTRATION:RESET_CHANGE_USER_GROUPS_VALIDATION',

  REQUEST_CHANGE_USERS: 'FAVOURITE_ADMINISTRATION:REQUEST_CHANGE_USERS',
  RECEIVE_CHANGE_USERS: 'FAVOURITE_ADMINISTRATION:RECEIVE_CHANGE_USERS',
  FAIL_CHANGE_USERS: 'FAVOURITE_ADMINISTRATION:FAIL_CHANGE_USERS',
  CHANGE_USERS_FIELDS_BY_KEY: 'FAVOURITE_ADMINISTRATION:CHANGE_USERS_FIELDS_BY_KEY',
  UPDATE_CHANGE_USERS_VALIDATION: 'FAVOURITE_ADMINISTRATION:UPDATE_CHANGE_USERS_VALIDATION',
  UPDATE_CHANGE_USERS_IS_DIRTY: 'FAVOURITE_ADMINISTRATION:UPDATE_CHANGE_USERS_IS_DIRTY',
  UPDATE_CHANGE_USERS_STATE: 'FAVOURITE_ADMINISTRATION:UPDATE_CHANGE_USERS_STATE',
  CLEAR_CHANGE_USERS: 'FAVOURITE_ADMINISTRATION:CLEAR_CHANGE_USERS',
  RESET_CHANGE_USERS_VALIDATION: 'FAVOURITE_ADMINISTRATION:RESET_CHANGE_USERS_VALIDATION',

  UPDATE_OWNERS_VALIDATION: 'FAVOURITE_ADMINISTRATION:UPDATE_OWNERS_VALIDATION',
  RESET_OWNERS_VALIDATION: 'FAVOURITE_ADMINISTRATION:RESET_OWNERS_VALIDATION',

  CLEAR_LIST: 'FAVOURITE_ADMINISTRATION:CLEAR_LIST'
};

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number, public model: FavouriteSearchModel, public clearResults: boolean) { }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(
    public requestId: number, 
    public list: FavouriteSearchData[], 
    public numberOfResults: number,
    public editableNumberOfResults: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) { }
}

export class RequestDeleteFavourite {
  public type: string = ACTION.REQUEST_DELETE_FAVOURITE;
  constructor(public id: number) { }
}

export class ReceiveDeleteFavourite {
  public type: string = ACTION.RECEIVE_DELETE_FAVOURITE;
  constructor(public id: number) { }
}

export class FailDeleteFavourite {
  public type: string = ACTION.FAIL_DELETE_FAVOURITE;
  constructor(public id: number) { }
}

export class RequestChangeOwner {
  public type: string = ACTION.REQUEST_CHANGE_OWNER;
}

export class ReceiveChangeOwner {
  public type: string = ACTION.RECEIVE_CHANGE_OWNER;
}

export class FailChangeOwner {
  public type: string = ACTION.FAIL_CHANGE_OWNER;
}

export class ChangeOwnerFieldsByKey {
  public type: string = ACTION.CHANGE_OWNER_FIELDS_BY_KEY;
  constructor(public key: string, public value: any) {
  }
}

export class UpdateChangeOwnerValidation {
  public type: string = ACTION.UPDATE_CHANGE_OWNER_VALIDATION;
  constructor(public validation: { [key: string]: ValidationProps }) {
  }
}

export class UpdateChangeOwnerIsDirty {
  public type: string = ACTION.UPDATE_CHANGE_OWNER_IS_DIRTY;
  constructor(public isDirty: boolean) {
  }
}

export class ClearChangeOwner {
  public type: string = ACTION.CLEAR_CHANGE_OWNER;
}

export class ResetChangeOwnerValidation {
  public type: string = ACTION.RESET_CHANGE_OWNER_VALIDATION;
  constructor(public key: string) {
  }
}

export class RequestChangeUserGroups {
  public type: string = ACTION.REQUEST_CHANGE_USER_GROUPS;
}

export class ReceiveChangeUserGroups {
  public type: string = ACTION.RECEIVE_CHANGE_USER_GROUPS;
}

export class FailChangeUserGroups {
  public type: string = ACTION.FAIL_CHANGE_USER_GROUPS;
}

export class ChangeUserGroupsFieldsByKey {
  public type: string = ACTION.CHANGE_USER_GROUPS_FIELDS_BY_KEY;
  constructor(public key: string, public value: any) {
  }
}

export class UpdateChangeUserGroupsValidation {
  public type: string = ACTION.UPDATE_CHANGE_USER_GROUPS_VALIDATION;
  constructor(public validation: { [key: string]: ValidationProps }) {
  }
}

export class UpdateChangeUserGroupsIsDirty {
  public type: string = ACTION.UPDATE_CHANGE_USER_GROUPS_IS_DIRTY;
  constructor(public isDirty: boolean) {
  }
}

export class UpdateChangeUserGroupsState {
  public type: string = ACTION.UPDATE_CHANGE_USER_GROUPS_STATE;
  constructor(public state: ChangeOptionType) {
  }
}

export class ClearChangeUserGroups {
  public type: string = ACTION.CLEAR_CHANGE_USER_GROUPS;
}

export class ResetChangeUserGroupsValidation {
  public type: string = ACTION.RESET_CHANGE_USER_GROUPS_VALIDATION;
  constructor(public key: string) {
  }
}

export class RequestChangeUsers {
  public type: string = ACTION.REQUEST_CHANGE_USERS;
}

export class ReceiveChangeUsers {
  public type: string = ACTION.RECEIVE_CHANGE_USERS;
}

export class FailChangeUsers {
  public type: string = ACTION.FAIL_CHANGE_USERS;
}

export class ChangeUsersFieldsByKey {
  public type: string = ACTION.CHANGE_USERS_FIELDS_BY_KEY;
  constructor(public key: string, public value: any) {
  }
}

export class UpdateChangeUsersValidation {
  public type: string = ACTION.UPDATE_CHANGE_USERS_VALIDATION;
  constructor(public validation: { [key: string]: ValidationProps }) {
  }
}

export class UpdateChangeUsersIsDirty {
  public type: string = ACTION.UPDATE_CHANGE_USERS_IS_DIRTY;
  constructor(public isDirty: boolean) {
  }
}

export class UpdateChangeUsersState {
  public type: string = ACTION.UPDATE_CHANGE_USERS_STATE;
  constructor(public state: ChangeOptionType) {
  }
}

export class UpdateOwnersValidation {
  public type: string = ACTION.UPDATE_OWNERS_VALIDATION;
  constructor(public validation: { [key: string]: ValidationProps }) {
  }
}

export class ResetOwnersValidation {
  public type: string = ACTION.RESET_OWNERS_VALIDATION;
}

export class ClearChangeUsers {
  public type: string = ACTION.CLEAR_CHANGE_USERS;
}

export class ResetChangeUsersValidation {
  public type: string = ACTION.RESET_CHANGE_USERS_VALIDATION;
  constructor(public key: string) {
  }
}

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}
